var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDowngray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.913 11.208a.848.848 0 0 1-.59-.236L2.195 6.026a.786.786 0 0 1 0-1.14.857.857 0 0 1 1.181 0l4.537 4.378 4.537-4.377a.857.857 0 0 1 1.181 0 .786.786 0 0 1 0 1.14l-5.128 4.947a.848.848 0 0 1-.59.235z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDowngray);
export default __webpack_public_path__ + "static/media/arrow-down.gray.46abf0b382fbfab001dff8e1e6e55dec.svg";
export { ForwardRef as ReactComponent };